export default __webpack_public_path__ + "static/media/landing3.aef4ef97.jpg";